import { useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/styles';
export function useIsMobile() {
    const theme = useTheme();
    return useMediaQuery(theme.breakpoints.down(theme.breakpoints.values.sm));
}
//# sourceMappingURL=useIsMobile.js.map